// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';
import t from './types';

export function useLogoLibrary(props?) {
  return useRequestQuery(
    [t.LOGO_LIBRARY],
    { method: 'get', url: 'logo-library' },
    {
      select: (res) => res.data,
      defaultData: [],
      ...props,
    },
  );
}

export function useCreateLogoLibrary(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((values) => apiRequest.post('logo-library', values), {
    onSuccess: () => {
      queryClient.invalidateQueries(t.LOGO_LIBRARY);
    },
    ...props,
  });
}

export function useEditLogoLibrary(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([id, values]) => apiRequest.patch(`logo-library/${id}`, values),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(t.LOGO_LIBRARY);
      },
      ...props,
    },
  );
}

export function useDeleteLogoLibrary(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    (id: number) => apiRequest.delete(`logo-library/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(t.LOGO_LIBRARY);
      },
      ...props,
    },
  );
}
